import E2E_PAGE_PREFIX from '../../e2ePrefix';

const E2E_PREFIX = `${E2E_PAGE_PREFIX}-purchase-orders-reference-popup`;

export default E2E_PREFIX;
